// Remove null values so AWS does freak TF out....
export const removeNullValues = (data) => {
    Object.keys(data).forEach((key) => {
        if (!data[key] || data[key] === "") {
            delete data[key];
        }
    });
};
export const isEqual = (value1, value2) => {
    // Check if both values are strictly equal
    if (value1 === value2) {
        return true;
    }
    // Check if either value is null or undefined (but they are not strictly equal)
    if (value1 == null || value2 == null) {
        return false;
    }
    // Check if both values are objects (and not arrays)
    if (typeof value1 === "object" &&
        typeof value2 === "object" &&
        !Array.isArray(value1) &&
        !Array.isArray(value2)) {
        const keys1 = Object.keys(value1);
        const keys2 = Object.keys(value2);
        // Check if both objects have the same number of keys
        if (keys1.length !== keys2.length) {
            return false;
        }
        // Check if all keys and values are equal
        for (const key of keys1) {
            if (!keys2.includes(key) || !isEqual(value1[key], value2[key])) {
                return false;
            }
        }
        return true;
    }
    // Check if both values are arrays
    if (Array.isArray(value1) && Array.isArray(value2)) {
        // Check if both arrays have the same length
        if (value1.length !== value2.length) {
            return false;
        }
        // Check if all array elements are equal
        for (let i = 0; i < value1.length; i++) {
            if (!isEqual(value1[i], value2[i])) {
                return false;
            }
        }
        return true;
    }
    // If the values are of different types or don't match any of the above cases
    return false;
};
// Removes the __typename field from the input by building a new object with all the same keys and values that are NOT __typename
// This is used when the output of one resolver, gets plugged into the input of another resolver.
// For example, when we get priority views, we take the filter and use it as the search body for priorty entries.
export const removeTypename = (input) => {
    if (Array.isArray(input)) {
        return input.map(removeTypename);
    }
    if (input !== null && typeof input === "object") {
        const result = {};
        for (const key in input) {
            // Remove the __typename field; include all values except null/undefined (preserve false, 0, "")
            const value = input[key];
            if (key !== "__typename" && value != null) {
                result[key] = removeTypename(value);
            }
        }
        return result;
    }
    return input;
};
